import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Config } from '../../environments/environment';

@Component({
  selector: 'uppy-callback',
  template: `
    <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: sans-serif;">
      <div style="text-align: center;">
        <h3>Authentication successful!</h3>
        <p>This window will close automatically...</p>
      </div>
    </div>
  `,
  standalone: true
})
export class UppyCallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const provider = this.route.snapshot.queryParamMap.get('provider');

    if (token) {
      // Store token in localStorage - triggers 'storage' event in parent window
      const data = JSON.stringify({
        token: token,
        provider: provider,
        timestamp: Date.now()
      });

      localStorage.setItem('uppy-auth-token', data);

      // Also store with provider-specific key for cloud file downloads
      if (provider) {
        localStorage.setItem(`companion-${provider}-auth-token`, token);
      }

      console.log('[uppy-callback] Token stored in localStorage for provider:', provider);

      // Also try postMessage if opener exists
      if (window.opener) {
        try {
          const companionOrigin = new URL(Config.COMPANION_URL).origin;
          window.opener.postMessage({ uppyAuthToken: token }, '*');
          console.log('[uppy-callback] Token sent via postMessage');
        } catch (e) {
          console.log('[uppy-callback] postMessage not available');
        }
      }
    }

    // Close window after short delay
    setTimeout(() => {
      window.close();
    }, 300);
  }
}
